module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    style: (_vm.highlightStyle.container),
    attrs: {
      "kbx-highlight-hover-container": ""
    }
  }, [_c('div', {
    attrs: {
      "kbx-highlight-hover": "top"
    }
  }), _vm._v(" "), _c('div', {
    style: (_vm.highlightStyle.right),
    attrs: {
      "kbx-highlight-hover": "right"
    }
  }), _vm._v(" "), _c('div', {
    style: (_vm.highlightStyle.bottom),
    attrs: {
      "kbx-highlight-hover": "bottom"
    }
  }), _vm._v(" "), _c('div', {
    style: (_vm.highlightStyle.left),
    attrs: {
      "kbx-highlight-hover": "left"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "klickart-element-highlight-tool-container"
  }, [_c('button', {
    staticClass: "klickart-highlight-tool",
    on: {
      "click": function($event) {
        _vm.sidebarChangePanel('modifiers');
        _vm.sidebarChangeActiveButton('style');
        _vm.sidebarSetElement(_vm.highlightElement)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-cog"
  })])])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-0b0a61a4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/canvas/preview/Highlight.vue
 ** module id = 757
 ** module chunks = 1
 **/